var _circle, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCompetitionDetailsAboutImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 66,
    viewBox: "0 0 145 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 70,
    cy: 33,
    r: 33,
    fill: "#F69117"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.5 39C138.508 39 145 32.5081 145 24.5C145 16.4919 138.508 10 130.5 10C122.492 10 116 16.4919 116 24.5C116 32.5081 122.492 39 130.5 39ZM136.203 22.7029C136.821 22.0846 136.821 21.0821 136.203 20.4637C135.585 19.8454 134.582 19.8454 133.964 20.4637L128.75 25.6775L126.703 23.6304C126.085 23.0121 125.082 23.0121 124.464 23.6304C123.845 24.2487 123.845 25.2513 124.464 25.8696L127.63 29.0363C128.249 29.6546 129.251 29.6546 129.87 29.0363L136.203 22.7029Z",
    fill: "#F79319"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5 51C21.7467 51 26 46.7467 26 41.5C26 36.2533 21.7467 32 16.5 32C11.2533 32 7 36.2533 7 41.5C7 46.7467 11.2533 51 16.5 51ZM20.6705 39.9916C21.1098 39.536 21.1098 38.7973 20.6705 38.3417C20.2312 37.8861 19.5188 37.8861 19.0795 38.3417L15.375 42.1834L13.9205 40.675C13.4812 40.2194 12.7688 40.2194 12.3295 40.675C11.8902 41.1307 11.8902 41.8693 12.3295 42.325L14.5795 44.6583C15.0188 45.1139 15.7312 45.1139 16.1705 44.6583L20.6705 39.9916Z",
    fill: "#F79319"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 22C10.0899 22 13 19.0899 13 15.5C13 11.9101 10.0899 9 6.5 9C2.91015 9 0 11.9101 0 15.5C0 19.0899 2.91015 22 6.5 22ZM9.74372 14.4226C10.0854 14.0972 10.0854 13.5695 9.74372 13.2441C9.40201 12.9186 8.84799 12.9186 8.50628 13.2441L5.625 15.9882L4.49372 14.9107C4.15201 14.5853 3.59799 14.5853 3.25628 14.9107C2.91457 15.2362 2.91457 15.7638 3.25628 16.0893L5.00628 17.7559C5.34799 18.0814 5.90201 18.0814 6.24372 17.7559L9.74372 14.4226Z",
    fill: "#F79319"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.3187 37.3187C58.8034 35.8341 60.817 35 62.9167 35H74C76.0996 35 78.1133 35.8341 79.5979 37.3187C81.0826 38.8034 81.9167 40.817 81.9167 42.9167V46.0833C81.9167 46.9578 81.2078 47.6667 80.3333 47.6667C79.4589 47.6667 78.75 46.9578 78.75 46.0833V42.9167C78.75 41.6569 78.2496 40.4487 77.3588 39.5579C76.468 38.6671 75.2598 38.1667 74 38.1667H62.9167C61.6569 38.1667 60.4487 38.6671 59.5579 39.5579C58.6671 40.4487 58.1667 41.6569 58.1667 42.9167V46.0833C58.1667 46.9578 57.4578 47.6667 56.5833 47.6667C55.7089 47.6667 55 46.9578 55 46.0833V42.9167C55 40.817 55.8341 38.8034 57.3187 37.3187Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.4596 18.1667C65.8363 18.1667 63.7096 20.2933 63.7096 22.9167C63.7096 25.54 65.8363 27.6667 68.4596 27.6667C71.083 27.6667 73.2096 25.54 73.2096 22.9167C73.2096 20.2933 71.083 18.1667 68.4596 18.1667ZM60.543 22.9167C60.543 18.5444 64.0874 15 68.4596 15C72.8319 15 76.3763 18.5444 76.3763 22.9167C76.3763 27.2889 72.8319 30.8333 68.4596 30.8333C64.0874 30.8333 60.543 27.2889 60.543 22.9167Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M92.5349 25.9637C93.1533 26.5821 93.1533 27.5846 92.5349 28.2029L86.2016 34.5363C85.5833 35.1546 84.5808 35.1546 83.9624 34.5363L80.7958 31.3696C80.1774 30.7513 80.1774 29.7487 80.7958 29.1304C81.4141 28.5121 82.4166 28.5121 83.035 29.1304L85.082 31.1775L90.2958 25.9637C90.9141 25.3454 91.9166 25.3454 92.5349 25.9637Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCompetitionDetailsAboutImage);
export default __webpack_public_path__ + "static/media/competition-details-about-image.26d9061a2add6b8f74eca80e2077749c.svg";
export { ForwardRef as ReactComponent };